import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/app/(use-page-wrapper)/(main-nav)/availability/skeleton.tsx");
